<template>
  <page-list
    :list="list"
    :columns="columns"
    :single-actions="singleActions"
    :group-actions="groupActions"
    :export-data-options="exportDataOptions" />
</template>

<script>
import WindowsMixin from '@/mixins/windows'
import ListMixin from '@/mixins/list'
import {
  getNameFilter,
  getEnabledFilter,
  getTenantFilter,
  getDomainFilter,
} from '@/utils/common/tableFilter'
import ColumnsMixin from '../mixins/columns'
import SingleActionMixin from '../mixins/singleActions'

export default {
  name: 'BillSubscriptionList',
  mixins: [WindowsMixin, ListMixin, ColumnsMixin, SingleActionMixin],
  data () {
    return {
      list: this.$list.createList(this, {
        id: 'BillSubscriptionList',
        resource: 'costreports',
        apiVersion: 'v1',
        filterOptions: {
          name: getNameFilter(),
          enabled: getEnabledFilter(),
          project: getTenantFilter(),
          project_domain: getDomainFilter(),
        },
      }),
      groupActions: [
        {
          label: this.$t('bill.text_193'),
          action: () => {
            this.$router.push({
              path: '/billsummary/subscriptioncreate',
            })
          },
          meta: () => {
            return {
              buttonType: 'primary',
            }
          },
        },
        {
          label: this.$t('common.batchAction'),
          actions: () => {
            return [
              {
                label: this.$t('bill.text_194'),
                action: () => {
                  this.list.batchPerformAction('enable', null)
                },
                meta: () => {
                  const validate = this.list.selectedItems.length && this.list.selectedItems.some(item => !item.enabled)
                  return {
                    validate,
                    tooltip: !validate ? this.$t('bill.subscription_validate_disable') : '',
                  }
                },
              },
              {
                label: this.$t('bill.text_196'),
                action: () => {
                  this.createDialog('SubscriptionSetDisabledDialog', {
                    columns: this.columns,
                    data: this.list.selectedItems,
                    onManager: this.onManager,
                  })
                },
                meta: () => {
                  const validate = this.list.selectedItems.length && this.list.selectedItems.some(item => item.enabled)
                  return {
                    validate,
                    tooltip: !validate ? this.$t('bill.subscription_validate_enable') : '',
                  }
                },
              },
              {
                label: this.$t('cloudenv.text_108'),
                action: () => {
                  this.createDialog('DeleteResDialog', {
                    vm: this,
                    data: this.list.selectedItems,
                    columns: this.columns,
                    title: this.$t('bill.text_167'),
                    name: this.$t('bill.subscription'),
                    onManager: this.onManager,
                  })
                },
                meta: () => {
                  const validate = this.list.selectedItems.length
                  return {
                    // validate: this.list.allowDelete(),
                    validate,
                    tooltip: !validate ? this.$t('bill.subscription_validate_delete') : '',
                  }
                },
              },
            ]
          },
        },
      ],
      exportDataOptions: {
        items: [
          { label: this.$t('bill.text_88'), key: 'name' },
          { label: this.$t('table.title.enable_status'), key: 'enabled' },
          { label: this.$t('bill.subscription_scope'), key: 'project_domain' },
          { label: this.$t('bill.budget_currency'), key: 'billing_type' },
          { label: this.$t('bill.alert_frequency'), key: 'period_type' },
          { label: this.$t('bill.subscription_mail_subject'), key: 'subject' },
          { label: this.$t('common.createdAt'), key: 'created_at' },
        ],
      },
    }
  },
  created () {
    this.fetchData()
  },
  methods: {
    fetchData () {
      this.list.fetchData()
    },
    handleOpenSidepage (row) {
      this.sidePageTriggerHandle(this, 'SubscriptionListSidePage', {
        id: row.id,
        resource: () => {
          return {
            data: row,
          }
        },
      }, {
        list: this.list,
      })
    },
  },
}
</script>
